import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import check_45maintenance_45global from "/app/app/middleware/checkMaintenance.global.ts";
import clear_45user_45cache_45global from "/app/app/middleware/clearUserCache.global.ts";
import disable_45test_45routes_45global from "/app/app/middleware/disableTestRoutes.global.ts";
import external_45redirect_45global from "/app/app/middleware/externalRedirect.global.ts";
import is_45game_45active_45global from "/app/app/middleware/isGameActive.global.ts";
import require_45auth_45global from "/app/app/middleware/requireAuth.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  check_45maintenance_45global,
  clear_45user_45cache_45global,
  disable_45test_45routes_45global,
  external_45redirect_45global,
  is_45game_45active_45global,
  require_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}